<template><!-- 登録モーダル -->
<transition name="modal">
  <div class="modal-mask" @click="$emit('close')">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div>
        <CRow>
        <CCol class="scr">
          <table class="table">
            <thead>
              <a style="font-size: 20px"><strong>登録内容確認</strong></a>
              <CCardText><strong>以下の内容を登録してよろしいですか？</strong></CCardText>
            </thead>
            <tbody>
              <tr>
                <td>
                  <a><strong>取引先企業</strong></a><br>
                  {{ name }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>取引先担当者名</strong></a><br>
                  {{ staff_name }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>電話番号</strong></a><br>
                  {{ tel }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>住所</strong></a><br>
                  {{ address }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>E-Mail</strong></a><br>
                  {{ mail }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>支払いサイト</strong></a><br>
                  {{ usance }}(日)
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>備考</strong></a><br>
                  {{ remarks }}
                </td>
              </tr>
            </tbody>
          </table>
        </CCol>
        </CRow>
        <CRow>
          <CCol>
            <button @click="$emit('close')" class="btn btn-secondary btn-sm">キャンセル</button>
          </CCol>
          <CCol>
            <save-button
              :label="'登録'"
              :loading="loading"
              :disabled="authorized"
              @click="$emit('register')"
              class="btn btn-info"
            />
          </CCol>
        </CRow>
        </div>
      </div>
    </div>
  </div>
</transition>
</template>

<script>
import SaveButton from '../common/SaveButton'
export default {
  components: { SaveButton },
  name: 'RegisterModal',
  data () {
    return {
    }
  },
  props: {
    name: String,
    staff_name: String,
    tel: String,
    address: String,
    mail: String,
    usance: String,
    remarks: String,
    authorized: Boolean,
    loading: Boolean,
  }
}
</script>

<style scoped>
td {
  word-break: break-all;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(80, 80, 80, 0.5);
  display: table;
  transition: opacity .3s ease;
  }
  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }
  .modal-container {
    width: 40%;
    margin: 0px auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }
  .scr{
    overflow: auto;
  }
</style>
